import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsitePartnerFragment } from 'bundles/ent-website/queries/EntWebsitePartnerList';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteTestimonialFragment = contentfulGql`#graphql
  ${imageFragment}
  ${entWebsitePartnerFragment}
  fragment EntWebsiteTestimonial on EntWebsiteTestimonial {
    slug
    author
    authorTitle
    authorAvatar {
      ...Image
    }
    authorOrganization {
      ...EntWebsitePartner
    }
    headline
    testimonial
  }
`;

export const entWebsiteBlockTestimonialQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteTestimonialFragment}
  query entWebsiteBlockTestimonial($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteTestimonial
      }
    }
  }
`;
